import React, { Component } from "react";
import GisapTokenEdit from "components/GisapTokenEdit";

export default class ServerSideToken extends Component {
  render() {
    return <GisapTokenEdit />;
  }
}
